import axios from '../../axios-dashboard'

import * as actionTypes from './actionTypes'

export const fetchBudgetStart = () => {
    return {
        type: actionTypes.BUDGET_FETCH_START
    }
};

export const fetchBudgetSuccess = (budget) => {
    return {
        type: actionTypes.BUDGET_FETCH_SUCCESS,
        budget: budget,
    }
};

export const fetchBudgetFail = (error) => {
    return {
        type: actionTypes.BUDGET_FETCH_FAIL,
        error: error,
    }
};

export const fetchBudget = (token) => {
    return dispatch => {
        if (!token) {
            return
        }
        dispatch(fetchBudgetStart());
        let url = "/budget";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url, {
            action: 'getBudgets'
        }).then(response => {
            dispatch(fetchBudgetSuccess(response.data))
        }).catch(err => {
            dispatch(fetchBudgetFail(err.response.data.error))
        })
    }
};


export const saveBudgetStart = () => {
    return {
        type: actionTypes.SAVE_BUDGET_START,
    }
};

export const saveBudgetSuccess = (budget) => {
    return {
        type: actionTypes.SAVE_BUDGET_SUCCESS,
        budget: budget,
    }
};

export const saveBudgetFail = (error) => {
    return {
        type: actionTypes.SAVE_BUDGET_FAIL,
        error: error,
    }
};

export const saveBudget = (token, budget) => {
    return dispatch => {
        if (!token) {
            return
        }
        dispatch(saveBudgetStart())
        let url = "/budget";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url, {
            action: 'updateBudgets',
            budget: budget,
        }).then(response => {
            dispatch(saveBudgetSuccess(response.data))
        }).catch(err => {
            dispatch(saveBudgetFail(err.response.data.error))
        })
    }
};